import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  editButton: {
    id: 'aWZuFh',
    defaultMessage: 'Edit',
    description: 'Edit button label in workflow detail',
  },
  editButtonAriaLabel: {
    id: 'lF7TDX',
    defaultMessage: 'Edit workflow',
    description: 'Aria label for the edit workflow button',
  },
  noDescription: {
    id: '3P6KH5',
    defaultMessage: 'No description provided',
    description: 'Placeholder shown when a workflow has no description',
  },
  createdLabel: {
    id: 'ly9HvF',
    defaultMessage: 'Created: {date}',
    description: 'Label for the created date with the date value interpolated',
  },
  updatedLabel: {
    id: 'TG74QA',
    defaultMessage: 'Updated: {date}',
    description: 'Label for the updated date with the date value interpolated',
  },
  summaryHeader: {
    id: 'G42iTL',
    defaultMessage: "Here's what this automation workflow will do:",
    description: 'Header for the read-only workflow steps summary',
  },
  stepSummary: {
    id: 'vroJWr',
    defaultMessage: '{filterCount, plural, one {# filter} other {# filters}} and {actionCount, plural, one {# action} other {# actions}}',
    description: 'Summary of filter and action counts for a workflow step',
  },
  zoomButton: {
    id: 'cw88UT',
    defaultMessage: 'Zoom',
    description: 'Zoom button label in workflow detail — opens the zoomable workflow drawer',
  },
  zoomButtonAriaLabel: {
    id: 'CQlCuQ',
    defaultMessage: 'Open zoomable view for workflow',
    description: 'Aria label for the zoom workflow button',
  },
});
